import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { resumeSubscription } from '../actions/SubscriptionsActions';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';

export const ResumeSubscriptionEntityAction: IEntityAction<ISubscriptionInfo, {}> = {
  name: EntityActionNames.SubscriptionResume,
  translateName: Messages.resumeSubscription_action,
  isVisible: (subscriptions: ISubscriptionInfo[]) => FeatureFlags.suspendSubscriptions && subscriptions.length === 1 && subscriptions[0].suspended,
  isClickable: () => true,
  createReduxAction: (subscriptions: ISubscriptionInfo[]) => resumeSubscription(subscriptions[0])
};
